import React from 'react'
import moment from 'moment';
import { Tooltip } from "antd";
import { Download } from 'react-feather';
import { fetchAppFileDoc } from '../../../stores/slices/document/documentDownloadSlice';
import Table from '../../../components/reactTable/Table';
import { useDispatch, useSelector } from "react-redux";
import { API_TRACE, DOCSTUDIO_ATTACHMENT_REPLACE_URL, DOCSTUDIO_HTML_REPLACE_URL, DOCSTUDIO_REPLACE_LIVE_URL, DOCSTUDIO_REPLACE_URL, OLD_DOCSTUDIO_ATTACHMENT_REPLACE_URL, OLD_DOCSTUDIO_HTML_REPLACE_URL, OLD_DOCSTUDIO_REPLACE_LIVE_URL, OLD_DOCSTUDIO_REPLACE_URL, SUBSCRIPTION_KEY, UAT_DOCSTUDIO_REPLACE_URL } from '../../../constant/Constants';
import { getAllSessions } from '../../../utilities/API/supertokenServices';


function Attachments() {
  const dispatch = useDispatch();

  const ClaimData = useSelector((state) => state.claimDetailSlice);
  const loginData = useSelector((state) => state.loginSlice);
  const sessionData = useSelector((state) => state.sessionSlice)

  const downloadDoc = (props) => {
    let data = props.row.original ? props.row.original : props;
    if (data.pxPages.DataWorkAttachURL.pyURL != undefined) {
      let cURL = '';
      if(data.pxPages.DataWorkAttachURL.pyURL.indexOf('https://cpr-docstudio.patientadvocate.org/') != '-1'){
        cURL =data.pxPages.DataWorkAttachURL.pyURL.replace('https://cpr-docstudio.patientadvocate.org/', DOCSTUDIO_REPLACE_URL);         
    }else if(data.pxPages.DataWorkAttachURL.pyURL.indexOf('https://docstudio-cpr.patientadvocate.org:8443/') != '-1'){
        cURL =data.pxPages.DataWorkAttachURL.pyURL.replace('https://docstudio-cpr.patientadvocate.org:8443/', OLD_DOCSTUDIO_REPLACE_URL);
    }else{
        cURL =data.pxPages.DataWorkAttachURL.pyURL.replace('https://cpr-uat-docstudio.patientadvocate.org/', UAT_DOCSTUDIO_REPLACE_URL); 
    }



      const fileName = data.pxPages.LinkAttach.pyMemo;
      fetch(cURL, {
        method: 'GET',
        headers: {
          'Ocp-Apim-Subscription-Key': SUBSCRIPTION_KEY,
          'Ocp-Apim-Trace': API_TRACE
        }
      }).then(function (t) {
        return t.blob().then((b) => {
          var a = document.createElement("a");
          a.href = URL.createObjectURL(b);
          a.setAttribute("download", fileName);
          a.click();
        });
      });
    } else {
        dispatch(fetchAppFileDoc({ DocumentID: data.pxPages.LinkAttach.pzInsKey, prgData: ClaimData.program, reqstData: data }))
    }
  }

  const claimsColumns = React.useMemo(
    () => [{
      Header: 'POE ID',
      accessor: '' // String-based value accessors!
    }, {
      Header: 'POE ID',
      accessor: 'pyID' // String-based value accessors!
    },
    {
      Header: 'FileName',
      accessor: 'pxPages.LinkAttach.pyMemo' // String-based value accessors!
    },
    {
      Header: 'Created Date',
      accessor: 'pxPages.LinkAttach.pxCreateDateTime',
      Cell: props => {
        let data = props.value;
        // let splitDate = data.substring(0, 8);
        let dateformat = moment(data).format('L')
        return <span>{dateformat}</span>
      } // String-based value accessors!
    },
    {
      Header: 'Action',
      Cell: props => {
        return <div className="d-flex justify-content-center align-items-center">
          <Tooltip placement="top" title={'Download'} >
            <button className="btn d-flex align-items-center me-3  bg-theme-9 cursor-pointer txt-white" onClick={() => { downloadDoc(props) }}> <div className="h-15"> <Download /> </div></button>
          </Tooltip>

        </div>
      },
    },])
  return (
    <div>    <div class="intro-y box mt-lg-5">
      <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
        <h2 class="fw-medium fs-base me-auto">
          Attachments
        </h2>
      </div>
      {ClaimData.attachments.length > 0 ?
        <Table columns={claimsColumns} data={ClaimData.attachments} showPageDataCount={5} searchFilter={true}></Table>
        : <div className="intro-y box mt-lg-5 text-center">No documents</div>}
    </div></div>
  )
}

export default Attachments